import { render } from "./BannerAtom.vue?vue&type=template&id=0edf15c9&scoped=true"
import script from "./BannerAtom.vue?vue&type=script&lang=js"
export * from "./BannerAtom.vue?vue&type=script&lang=js"

import "./BannerAtom.vue?vue&type=style&index=0&id=0edf15c9&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edf15c9"]])

export default __exports__